'use client';

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultMenuIcon = /*#__PURE__*/React.memo(function DefaultMenuIcon() {
  return /*#__PURE__*/_jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    style: {
      width: '1em',
      height: '1em'
    },
    children: /*#__PURE__*/_jsx("path", {
      d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
    })
  });
});
if (process.env.NODE_ENV !== "production") DefaultMenuIcon.displayName = "DefaultMenuIcon";
export default DefaultMenuIcon;